"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _utils = require("@package/utils");

var _notification = require("@widget/notification");

var _profile = require("@widget/profile");

var _functionalButton = require("@widget/functional-button");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Header() {
  try {
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var isInvoiceAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'operation.invoice.add');
    var isPayoutAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'operation.payout.add');
    var isShopAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'shop.add');
    var isUserAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'user.add');
    var isNotificationsPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'notification.get');
    var hasPermissions = isInvoiceAddPermission || isPayoutAddPermission || isShopAddPermission || isUserAddPermission;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_defaultModule["default"]['logotype'], 'icon-pikassa')
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, hasPermissions && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['functions']
    }, /*#__PURE__*/_react["default"].createElement(_functionalButton.Widget, null)), isNotificationsPermission && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['notifications']
    }, /*#__PURE__*/_react["default"].createElement(_notification.Widget, null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['profile']
    }, /*#__PURE__*/_react["default"].createElement(_profile.Widget, null))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Header;
exports["default"] = _default;